import { render, staticRenderFns } from "./LinkInput.vue?vue&type=template&id=64fb477d&scoped=true"
import script from "./LinkInput.vue?vue&type=script&lang=js"
export * from "./LinkInput.vue?vue&type=script&lang=js"
import style0 from "./LinkInput.vue?vue&type=style&index=0&id=64fb477d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fb477d",
  null
  
)

export default component.exports